import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './HeroSection.module.scss';

const HeroSection = () => {
    const navigate = useNavigate();

    const handleLearnMore = () => {
        const el = document.getElementById('features');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section className={styles.heroSection} aria-label="Hero">
            <div className={styles.content}>
                {/* Badge */}
                <div className={styles.badge}>
                    <span className={styles.pulseDot} aria-hidden="true" />
                    <span>FOUNDING MEMBER RECRUITING</span>
                </div>

                {/* Headline */}
                <h1 className={styles.headline}>
                    The SAT Tutor That{' '}
                    <span className={styles.highlight}>Never Gives Up</span>
                    {' '}on You
                </h1>

                {/* Subtext */}
                <p className={styles.subtext}>
                    Practice sessions that adapt to your weak spots, instant explanations with a system built by tutors who've helped 100+ students hit their target score.
                </p>

                {/* CTAs */}
                <div className={styles.ctaRow}>
                    <button
                        className={styles.btnPrimary}
                        onClick={() => navigate('/sign-up')}
                    >
                        Join Now
                    </button>
                    <button
                        className={styles.btnGhost}
                        onClick={handleLearnMore}
                    >
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M8 3v10M3 8l5 5 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Learn More
                    </button>
                </div>
            </div>

            {/* Hero Visual */}
            <div className={styles.mockupWrapper}>
                <img
                    src={process.env.PUBLIC_URL + '/assets/hero-chatbot-visual.svg'}
                    alt="Prepal chatbot preview"
                    className={styles.heroVisual}
                />
            </div>
        </section>
    );
};

export default HeroSection;
